"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createImThemeOptionsZenith = createImThemeOptionsZenith;
var _blurs = require("./internal/theme-options/blurs");
var _breakpoints = require("./internal/theme-options/breakpoints");
var _focusrings = require("./internal/theme-options/focusrings");
var _gradients = require("./internal/theme-options/gradients");
var _spacing = require("./internal/theme-options/spacing");
var _typography = require("./internal/theme-options/typography");
var _getCustomizedComponents = require("./internal/getCustomizedComponents");
var _palettes = require("./internal/theme-options/palettes");
var _shadows = require("./internal/theme-options/shadows");
function createImThemeOptionsZenith(theme) {
  var palette = (0, _palettes.createImPalette)(theme);
  var shadows = (0, _shadows.createImShadows)();
  return {
    blurs: _blurs.blurs,
    breakpoints: _breakpoints.breakpoints,
    components: (0, _getCustomizedComponents.getCustomizedComponents)(),
    focusRings: _focusrings.focusRings,
    gradients: _gradients.gradients,
    palette: palette,
    shadows: shadows,
    shape: {
      borderRadius: 6
    },
    spacing: _spacing.spacing,
    typography: _typography.typography
  };
}